import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL;
class CartAPI {
  async fetchProduct(productId) {
    try {
      const { data } = await axios.get(`${apiUrl}/app/products/${productId}`);
      return data;
    } catch (error) {
      throw error;
    }
  }
}

const cartAPI = new CartAPI();

export default cartAPI;